import React, { useState } from 'react'
import '../../../styles/Pages/Auth/login.style.css'
import logo from '../../../assets/Images/loginImg/Login_logo.png'
import eyeOpenSvg from '../../../assets/Icons/Pages/Auth/eye_open.svg'
import eyeClosedSvg from '../../../assets/Icons/Pages/Auth/eye_closed.svg'
import arrow from '../../../assets/Icons/Pages/Auth/BsArrowRight.svg'
import LeftTemp from '../../../components/Auth/LeftTemp'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const Body = () => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className='login-body'>
      <Helmet>
        <title>Institute Login - OMS</title>
      </Helmet>
      <div className='login-left-container'>
        <LeftTemp />
      </div>
      <div className='login-right-container'>
        <h3>Institute log in</h3>
        <div className='login-form'>
          <img src={logo} alt="Logo" />
          <div className='login-form-wrapper'>
            <div className='email-container'>
              <label htmlFor="Email">Email</label>
              <input type="email" placeholder="Enter your Email" name='email' />
            </div>
            <div className='password-container'>
              <label htmlFor="password">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter your password"
                name='password'
              />
              <img
                src={showPassword ? eyeOpenSvg : eyeClosedSvg}
                alt="Toggle Password Visibility"
                className='eye-icon'
                onClick={togglePasswordVisibility}
              />
            </div>
            <div className='remember-me-container'>
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
            <button>Log in</button>
            <img src={arrow} alt="" className='arrow' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Body